<template>
    <div class="detail">
        <div class="top-content main_content">
            <TopMenus v-model="activeIndex"></TopMenus>
        </div>
        <div class="banner-box">
            <div class="main_content banner-content">
                <div class="banner">
                    <el-carousel indicator-position="outside" arrow="always" height="338rem">
                        <el-carousel-item class="carousel-item">
                            <img src="./images/untitled.495.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/untitled.496.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/untitled.499.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/untitled.502.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/untitled.506.png" alt="img"/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="info">
                    <div class="title"><span class="other-color"></span>快麦工业打印机</div>
                    <div class="sub-title">最大打印宽度80-108mm可选，疾速打印</div>
                    <div class="text">
                        通讯接口：usb<br/>
                        打印速度：max300mm/S<br/>
                        打印宽度：max108mm<br/>
                        适用：大型仓库、电商等大批量快递面单打印
                    </div>
                </div>
            </div>
        </div>
        <template v-if="activeIndex===0">
            <div class="main_content content-bg">
                <img src="./images/main.jpg" alt="bg">
                <img src="./images/1.jpg" alt="bg">
                <img src="./images/2.jpg" alt="bg">
                <img src="./images/3.jpg" alt="bg">
                <img src="./images/4.jpg" alt="bg">
                <img src="./images/5.jpg" alt="bg">
                <img src="./images/6.jpg" alt="bg">
                <img src="./images/7.jpg" alt="bg">
                <img src="./images/8.jpg" alt="bg">
                <img src="./images/9.jpg" alt="bg">
                <img src="./images/10.jpg" alt="bg">
                <img src="./images/11.jpg" alt="bg">
                <img src="./images/12.jpg" alt="bg">
            </div>
        </template>
        <div v-else-if="activeIndex===1" class="content-bg-cs"></div>
    </div>
</template>

<script>
import TopMenus from '@/views/printCenter/TopMenus.vue'

export default {
    name: "deviceDetail",
    components: {TopMenus},
    data() {
        return {
            activeIndex: 0
        };
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../../printCenter.scss";

.detail {
    .content-bg {
        img {
            width: 100%;
        }
    }

    .content-bg-cs {
    }
}
</style>
